import { useState, SyntheticEvent, useEffect, useContext } from 'react';
import Carousel from 'react-material-ui-carousel';
import { useNavigate, useLocation } from 'react-router-dom';
import { DataContext } from 'providers/data';

import { dataTab } from 'core/dataScheduling';
import { ParamsDataOrdersByCustomerId, ParamsPageWebView } from 'utils/typeServices';
import { GetOrderDetailScheduling } from 'services/scheduling/getOrderDetailScheduling';

import { Typography, Box } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';

import Modals from 'components/views/Modals';
import Collapse from '@mui/material/Collapse';
import ModalClube from 'components/views/ModalClube';
import ParseWebView from 'components/views/ParseWebView';
import { ButtonRectangle } from 'components/views/form/Button';
import { ContentBodyPage, ContentNewsPage, Banner } from 'components/views/ContainersPage';

import OpenedScheduling from 'components/views/Scheduling/OpenedScheduling';
import CompletedScheduling from 'components/views/Scheduling/CompletedScheduling';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import BannerClub2 from 'assets/images/banners/desk/banner-club2-desk.png';
import BannerApp from 'assets/images/banners/desk/banner-app-desk.png';

import { ReactComponent as IcIturanCheck } from 'assets/icons/ic-ituran-check.svg';

import { TabCustom, BoxCustom, TypographyLight, Ul } from './styles';

type Params = {
    text: string;
    value: string;
    exist: boolean;
    listScheduling?: Array<ParamsDataOrdersByCustomerId>;
}

const Scheduling = ({ isWebView }: ParamsPageWebView) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [value, setValue] = useState('5');
    const [showModal, setShowModal] = useState(false);
    const [showModalClube, setShowModalClube] = useState(false);
    const [listSchedule, setListSchedule] = useState<Array<Params>>();
    const [reschedulingFeeValue, setReschedulingFeeValue] = useState<number>();
    const { dataOrdersByCustomerId, dataGetPlatformRemoval, blockClick, dataFitClientScheduling, handleGetOrdersByCustomerId, handleGetInitialServices } = useContext(DataContext);

    const handleChange = (event: SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (!dataOrdersByCustomerId && localStorage.getItem('token')) {
            handleGetOrdersByCustomerId({ token: localStorage.getItem('token')! });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataOrdersByCustomerId, localStorage.getItem('token')]);

    useEffect(() => {
        if (dataOrdersByCustomerId) {
            let auxArray: Array<Params> = JSON.parse(JSON.stringify(dataTab));
            let openScheduleAux: Array<ParamsDataOrdersByCustomerId> = [];
            let listCompletedSchedulingAux: Array<ParamsDataOrdersByCustomerId> = [];

            dataOrdersByCustomerId.map((value) => (value.FL_RESCHEDULING || value.DS_STATUS === "Agendado") ? openScheduleAux.push(value) : listCompletedSchedulingAux.push(value));
            // eslint-disable-next-line array-callback-return
            openScheduleAux.map((value) => {
                switch (value.NR_TIPO_AGENDAMENTO) {
                    case 1:
                        auxArray[0].exist = true;
                        (auxArray[0].listScheduling?.findIndex(({ CD_AGENDAMENTO }) => CD_AGENDAMENTO === value.CD_AGENDAMENTO) === -1) && auxArray[0].listScheduling?.push(value);
                        break;
                    case 2:
                        auxArray[1].exist = true;
                        (auxArray[1].listScheduling?.findIndex(({ CD_AGENDAMENTO }) => CD_AGENDAMENTO === value.CD_AGENDAMENTO) === -1) && auxArray[1].listScheduling?.push(value);
                        break;
                    case 11:
                        auxArray[2].exist = true;
                        (auxArray[2].listScheduling?.findIndex(({ CD_AGENDAMENTO }) => CD_AGENDAMENTO === value.CD_AGENDAMENTO) === -1) && auxArray[2].listScheduling?.push(value);
                        break;
                    case 9: case 13:
                        auxArray[3].exist = true;
                        (auxArray[3].listScheduling?.findIndex(({ CD_AGENDAMENTO }) => CD_AGENDAMENTO === value.CD_AGENDAMENTO) === -1) && auxArray[3].listScheduling?.push(value);
                        break;
                }
            });

            listCompletedSchedulingAux.map((value) => (auxArray[4].listScheduling?.findIndex(({ CD_AGENDAMENTO }) => CD_AGENDAMENTO === value.CD_AGENDAMENTO) === -1) && auxArray[4].listScheduling?.push(value));

            auxArray && setListSchedule(auxArray);
            const selected = auxArray?.find(({ exist }) => exist);
            selected && setValue(selected?.value);
        }
    }, [dataOrdersByCustomerId]);

    useEffect(() => {
        if (dataOrdersByCustomerId && !reschedulingFeeValue) {
            const openSchedule = dataOrdersByCustomerId.find(({ FL_RESCHEDULING, DS_STATUS }) => FL_RESCHEDULING || DS_STATUS === "Agendado");
            if (openSchedule && localStorage.getItem('token')) {
                GetOrderDetailScheduling({ token: localStorage.getItem('token')!, cdPedido: String(openSchedule.CD_PEDIDO) })
                    .then(({ data }) => {
                        if (data && typeof data === 'object') {
                            setReschedulingFeeValue(data.VL_TOTAL);
                        }
                    });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataOrdersByCustomerId]);

    useEffect(() => {
        if ((dataFitClientScheduling === undefined) || (dataGetPlatformRemoval === undefined)) {
            if (isWebView && location?.search.includes('token')) {
                localStorage.clear();
                handleGetInitialServices({ token: location?.search.split('=')[1], isWebView: true });
                localStorage.setItem('token', location?.search.split('=')[1]);
            } else if (isWebView && localStorage.getItem('token')) {
                handleGetInitialServices({ token: localStorage.getItem('token')!, isWebView: true });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataFitClientScheduling, dataGetPlatformRemoval]);

    useEffect(() => {
        if (blockClick && dataGetPlatformRemoval?.length === 0 && dataOrdersByCustomerId) {
            if (!dataOrdersByCustomerId?.find(({ FL_RESCHEDULING }) => FL_RESCHEDULING === true) && dataOrdersByCustomerId?.find(({ NR_TIPO_AGENDAMENTO, NR_STATUS }) => NR_TIPO_AGENDAMENTO === 2 && NR_STATUS === 4)) {
                setShowModal(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blockClick, dataGetPlatformRemoval, dataOrdersByCustomerId]);

    return (
        <ParseWebView title={isWebView ? '' : 'AGENDAMENTOS'} typePage='page' isWebView={isWebView}>
            <ContentBodyPage>
                <Collapse in={(dataGetPlatformRemoval && dataGetPlatformRemoval?.length > 0) || (dataFitClientScheduling && dataFitClientScheduling.length > 0) ? true : false}>
                    <Box sx={{
                        cursor: 'pointer',
                        maxWidth: '41rem',
                        display: 'flex',
                        alignItems: 'center',
                        margin: { xs: '0 auto 0', md: '1.125rem auto 1.5rem' },
                        justifyContent: 'space-between',
                        border: '1.23363px solid #10A7E0',
                        padding: { xs: '.4rem .65rem 0', md: '0 2.4rem' }
                    }}
                        onClick={() => navigate('pendente')}
                    >
                        <Box sx={{ 'svg': { width: 'auto', height: { xs: '3.875rem', md: '5.3rem' } } }}>
                            <IcIturanCheck />
                        </Box>
                        <Box sx={{
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '6px',
                            maxWidth: { xs: '11.5rem', md: '100%' }
                        }}>
                            <Typography fontWeight={700} sx={{ fontSize: { xs: '.875rem', md: '1.375rem' } }}>
                                AGENDAMENTO PENDENTE
                            </Typography>
                            <Typography sx={{ fontSize: { xs: '.75rem', md: '1rem' }, lineHeight: '14px' }}>
                                Não deixe para depois, <strong>agende já!</strong>
                            </Typography>
                        </Box>
                        <ArrowForwardIosIcon sx={{ color: 'primary.light' }} />
                    </Box>
                </Collapse>
                <Box>
                    <TabContext value={value}>
                        <BoxCustom>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                {listSchedule?.map(({ text, value, exist }, index) =>
                                    exist && <TabCustom label={text} value={value} key={index} />
                                )}
                            </TabList>
                            <Box sx={{ borderBottom: '2.4px solid #8D9BB5', marginTop: '-2px' }} />
                        </BoxCustom>
                        {listSchedule?.map(({ value, exist, listScheduling }, index) =>
                            (exist && listScheduling && listScheduling.length > 0) && (
                                <TabPanel value={value} key={index} sx={{ padding: '1.25rem 0 0' }}>
                                    {value < '5' && listScheduling.map((openSchedule, index) =>
                                        <OpenedScheduling key={index} openSchedule={openSchedule} reschedulingFeeValue={reschedulingFeeValue} />
                                    )}
                                    {(value !== '5' && value !== '4') &&
                                        <Box>
                                            <TypographyLight sx={{ marginBottom: '.5rem' }}>
                                                * Regras de reagendamento:
                                            </TypographyLight>
                                            <Ul>
                                                <li>
                                                    <p>
                                                        O prazo de reagendamento é de 24 horas a data/hora agendada. Após este período, uma<br />
                                                        taxa de <strong>R$ {reschedulingFeeValue?.toFixed(2).replace('.', ',') ?? '50,00'}</strong> será cobrada para realizar o reagendamento. O boleto <strong>deverá</strong> ser<br />
                                                        quitado em até 3 horas antes da realização do serviço.
                                                    </p>
                                                </li>
                                            </Ul>
                                        </Box>
                                    }
                                    {value === '5' && <CompletedScheduling listCompletedScheduling={listScheduling} />}
                                </TabPanel>
                            )
                        )}
                    </TabContext>
                </Box>
            </ContentBodyPage>

            <ContentNewsPage>
                <Box sx={{ display: { xs: 'none', md: 'flex' }, width: '100%' }}>
                    <Carousel sx={{ width: '100%', minHeight: '27.25rem', 'button': { display: 'none' } }}>
                        <Banner bannerImg={BannerClub2} link='' onClick={() => setShowModalClube(true)} />
                        <Banner bannerImg={BannerApp} link='' />
                    </Carousel>
                </Box>
            </ContentNewsPage>

            <Modals open={showModal}>
                <Box sx={{ padding: '1.5rem 1rem .68rem', borderRadius: '8px 8px 0 0', textAlign: 'center', width: { xs: 'calc(100vw - 2rem)', md: 'auto' } }}>
                    <Typography fontSize='1.5625rem' fontWeight={700}>
                        ATENÇÃO!
                    </Typography>
                    <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                        Não há equipamentos a serem retirados.
                    </Typography>
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '2.25rem 3.81rem 2.06rem',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                        maxWidth: '15.68rem',
                    }
                }}>
                    <ButtonRectangle
                        name='FECHAR'
                        onClick={() => setShowModal(false)}
                    />
                </Box>
            </Modals>

            <ModalClube openModal={showModalClube} handleClickClosed={() => setShowModalClube(false)} />
        </ParseWebView >
    );
}

export default Scheduling;